import i18next from 'i18next';
import * as dayjs from 'dayjs';

const EN = 'en';

export default class LanguageService {
	private currentLanguage: string = EN;
	private initialized: boolean = false;
	private resources: any = {};

	fetchLanguage(languageCode: string) {
		try {
			if (this.resources[languageCode]) return;
			const languageTranslation = require(`../locales/${languageCode}.js`).default;
			this.resources[languageCode] = { translation: languageTranslation };
		} catch (e) {
			console.warn(`failed to fetch ${languageCode}`, e);
		}
	}

	translate(text, args) {
		return i18next.t(text, args);
	}

	loadDaysJsLocale(langCode: string = EN) {
		try {
			require(`dayjs/locale/${langCode}.js`);
			dayjs.locale(langCode);
		} catch (e) {
			console.warn(`Could not load language code: ${langCode}`, e);
		}
	}

	async init(languageCode?: string) {
		if (this.initialized && this.currentLanguage === languageCode) {
			return;
		}

		this.currentLanguage = languageCode || EN;

		this.loadDaysJsLocale(languageCode);
		this.fetchLanguage(EN);
		this.fetchLanguage(languageCode);

		this.initialized = true;

		return i18next.init({
			lng: this.currentLanguage,
			fallbackLng: EN,
			keySeparator: ' ',
			lowerCaseLng: true,
			pluralSeparator: '-',
			interpolation: {
				escapeValue: false // not needed for react!!
			},
			react: {
				defaultTransParent: 'div', // needed for preact
				wait: true,
				useSuspense: false
			},
			returnEmptyString: false,
			resources: this.resources
		});
	}
}
